
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facility-place/[id]/price",
      function () {
        return require("private-next-pages/facility-place/[id]/price.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facility-place/[id]/price"])
      });
    }
  